import React, { Fragment, useCallback, useState } from "react";
import axios from "axios";
import { Form } from "informed";
import { toast } from "react-toastify";
import { InputCell, InputTypeText } from "../elements";
import { API_URL } from "../../lib/const";
import { Link } from "react-router-dom";
import FlexVertical from "../components/FlexVertical";
import ButtonAuth from "../components/ButtonAuth";
import usePreference from "../../hooks/usePreference";
import useQueryString from "../../hooks/useQueryString";
import { useHistory } from "react-router-dom";
import { get } from "lodash";

const Logon = () => {
  const [loggingOn, setLoggingOn] = useState(false)
  const queryString = useQueryString();
  const history = useHistory();
  const requestPhoneNumberOnSignUpPreference = usePreference('request_phone_number_on_sign_up')
  let formApi = {};

  const createAccount = async (values) => {
    const response = await axios.post(`${API_URL}/login/register`, { ...values, username: values.email });

    return response.data;
  }

  const signIn = async (username, password) => {
    const response = await axios.post(`${API_URL}/login`, { username, password })

    return response.data;
  }

  const subscribeOnOnboardingProcess = async (userId, onboardingId) => {
    const response = await axios.post(`${API_URL}/onboarding/enrollments`, { onboarding: onboardingId, user: userId });

    return response.data;
  }

  const handleSubmit = useCallback(async (values) => {
    setLoggingOn(true)

    try {
      await createAccount(values)

      const { token, user, ...data } = await signIn(values.email, values.password)

      localStorage.setItem('token', token);
      localStorage.setItem('userId', user.id);

      setLoggingOn(false)

      if (queryString.get('processo')) {
        try {
          const { token } = await subscribeOnOnboardingProcess(user.id, queryString.get('processo'));

          history.push(`/inscrever/${token}`);

        } catch (err) {
          history.push('/processos', { ...data });
        }

      } else {
        history.push('/processos', { ...data });

      }

    } catch (error) {
      setLoggingOn(false)

      if (get(error, "response.status") === 400) {
        Object.entries(get(error, "response.data")).forEach((e) => {
          if (formApi.fieldExists(e[0])) {
            formApi.setError(e[0], e[1]);
          }
        });

      } else {
        toast.error("Erro inesperado. Por favor, tente novamente.");
      }
    }
  }, [queryString]);

  return (
    <Fragment>
      <div className="login-background">
        <Form getApi={(api) => { formApi = api; }} className="login-card shadow" onSubmit={handleSubmit}>
          <figure className="text-center mt-2">
            <img
              src={require("../../assets/img/logo-green.svg")}
              className="login-logo"
              alt="notification"
            />
          </figure>
          <InputTypeText
            label="Nome Completo"
            style={{ textTransform: "uppercase" }}
            type="text"
            field="last_name"
            helper="Insira o nome completo de acordo com seu documento de indentificação"
            required
          />
          <InputTypeText label="Email" type="email" field="email" required />
          {requestPhoneNumberOnSignUpPreference.data.value && <InputCell field="phone_number" label="Celular" helper="Ex: (31) 99999999" required />}
          <InputTypeText
            label="Senha"
            type="password"
            field="password"
            required
          />
          <InputTypeText
            label="Confirme sua senha"
            type="password"
            field="repeat_password"
            required
          />
          <FlexVertical height="100px">
            <ButtonAuth
              type="submit"
              disabled={loggingOn}
            >
              {loggingOn ? "Criando..." : "CRIAR ACESSO"}
            </ButtonAuth>
            <Link to={`/login?${queryString.toString()}`}>Já tenho uma conta</Link>
          </FlexVertical>
        </Form>
      </div>
    </Fragment>
  );
}

export default Logon;
